import { AppError, StateError } from '@model/common';

export const getErrorCode = (error: AppError): string => {
  if (!error) return '';
  const { errorCode, errorText, response } = error;
  return `${errorCode || response?.status || errorText || ''}`;
};

export const getError = (error: AppError): StateError => {
  return { code: getErrorCode(error), message: error.response?.data?.message || error.message };
};
